<template>
  <div
    :class="{ 'container': useContainer, 'redirect-block-select': blockParams?.isUrl }"
    :style="{
      'padding-top': paddingTop + 'px',
      'padding-bottom': paddingBottom + 'px'
    }"
    @click="$emit('block:redirect')"
  >
    <div
      class="information-showcase"
      :style="{
        'background-color': useBackgroundColor
      }"
    >
      <div class="information-showcase__image">
        <img
          :src="getSvgPath(mainFields.icon?.value)"
          loading="lazy"
          width="75"
          height="75"
        >
      </div>
      <div class="information-showcase__content">
        <h3>{{ mainFields.title?.value }}</h3>
        {{ mainFields.text?.value }}
      </div>
      <div class="information-showcase__aside">
        <nuxt-link :to="mainFields.link?.value" class="btn btn--fixed btn--mobile">
          Подробнее
        </nuxt-link>
      </div>
    </div>
  </div>
</template>

<script>
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default {
  mixins: [staticBlockMixin]
}
</script>
